export * from './indexing-settings-brand-categories.component';
